<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: '#0000002e',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        padding: '10px 15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: '10002'
    }">
        <van-loading type="spinner" size="60" />
    </van-popup>
</template>

<script setup lang="ts">
import { defineProps, ref, defineExpose } from 'vue'

const show = ref(false)

const props = defineProps({
    content: {
        type: String,
        default: () => ''
    },
    isLoading: {
        type: Boolean,
        default: () => false
    },
    isShowSuccess: {
        type: Boolean,
        default: () => false
    }
})
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
defineExpose({
    open,
    close
})

</script>
<style scoped>
.content {
    padding: 0 10px;
    font-size: 14px;
}

.van-overlay {
    background-color: #00000047
}
</style>